import { useDateRange } from './DateRangeProvider';
import { PresetList } from './Preset';
import type { DateRange } from './types';
import { toInputFormat } from './utils';

const DateRangePresets = () => {
  const { activePreset, presetOptions, setValue } = useDateRange();

  const onSelectPreset = (range: DateRange) => {
    setValue([toInputFormat(range.from), toInputFormat(range.to)]);
  };

  return (
    <PresetList
      presets={presetOptions}
      onChange={onSelectPreset}
      value={activePreset?.value}
    />
  );
};

export default DateRangePresets;
